import { render, staticRenderFns } from "./EditArrange.vue?vue&type=template&id=60349318&scoped=true&"
import script from "./EditArrange.vue?vue&type=script&lang=js&"
export * from "./EditArrange.vue?vue&type=script&lang=js&"
import style0 from "./EditArrange.vue?vue&type=style&index=0&id=60349318&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60349318",
  null
  
)

export default component.exports